/*
  <video-media> — click-to-play video (snippets/video-media.liquid).

  The page loads only a poster and a play button. The first click replaces the button with the
  player from the element's <template> (a Shopify <video>, or a YouTube / Vimeo iframe that
  autoplays), starts it and moves focus to it, so keyboard users land on the player controls.
  Load as a module from the section that renders a video.
*/
class VideoMedia extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.video-media__play');
    this.template = this.querySelector('template');
    if (!this.button || !this.template) return;
    this.handleClick = () => this.play();
    this.button.addEventListener('click', this.handleClick, { once: true });
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.handleClick);
  }

  play() {
    const content = this.template.content.cloneNode(true);
    const player = content.querySelector('video, iframe');
    this.button.replaceWith(content);
    this.classList.add('is-playing');
    if (!player) return;

    if (player instanceof HTMLVideoElement) {
      player.play().catch(() => {});
    }
    player.setAttribute('tabindex', '-1');
    player.focus({ preventScroll: true });
  }
}

if (!customElements.get('video-media')) {
  customElements.define('video-media', VideoMedia);

  // One video at a time: starting a Shopify-hosted video pauses the others on the page.
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('video-media')) return;
    document.querySelectorAll('video-media video').forEach((video) => {
      if (video !== event.target && !video.paused) video.pause();
    });
  }, true);
}
